import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import departmentResources from './departmentResources';
import editDepartmentResourceDialog from './dialog.editDepartmentResourceDialog';
import controller from './minimum-department-resources.controller';
import directive from './minimum-department-resources.directive';


export default angular.module('app.components.advisory.bcp.minimumDepartmentResources', [
  bcpDataService,
  constants,
  editDepartmentResourceDialog,
  loaderService,
  ssDialogService,
  userService,
  departmentResources,
])
  .directive('bcpMinimumDepartmentResources', directive)
  .controller('MinimumDepartmentResourcesController', controller)
  .name;

console.log('app.components.advisory.bcp.minimumDepartmentResources created');
